import { ui } from "@/components/ui";
import { services as s } from "@/services";
import { Link } from "@tanstack/react-router";
import { AlertTriangle, ChevronRight } from "lucide-react";

interface Props {
	diaryId: string;
	eventId: string;
}

const MissingInjectionsLink = (props: Props) => {
	return (
		<Link
			to="/diaries/$diaryId/edit/event/$eventId/injection/$injectionId"
			params={{
				diaryId: props.diaryId,
				eventId: props.eventId,
				injectionId: s.uuidv4(),
			}}
			className="flex justify-between items-center w-full"
		>
			<p className="flex items-center gap-2 text-amber-700 text-sm underline underline-offset-2">
				<AlertTriangle size={24} className=""></AlertTriangle>
				Add Missing Injection Details
			</p>
			<ui.Button
				asChild
				size="icon"
				variant="outline"
				className="p-0 pl-[2px] rounded-full w-8 h-8"
			>
				<ChevronRight size={24} />
			</ui.Button>
		</Link>
	);
};

export default MissingInjectionsLink;
